import { Component, OnInit, ChangeDetectorRef, EventEmitter, Output, Input, OnChanges } from '@angular/core';
import { KeyValueService } from '../key-value-service/key-value.service';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-key-value',
  templateUrl: './key-value.component.html',
  styleUrls: ['./key-value.component.scss']
})
export class KeyValueComponent implements OnInit, OnChanges {

  @Input() data;
  @Output() changes = new EventEmitter();
  items;

  constructor(private keyValueService: KeyValueService,
              private cd: ChangeDetectorRef) {
                this.items = [];
              }

  ngOnInit() {
    this.listenAddItem();
    this.listenDeleteItem();
  }

  ngOnChanges() {
    if (this.data && (this.data.length > 0)) {
      this.items = this.data;
    }
  }

  private listenAddItem() {
    this.keyValueService.listenAddItem().pipe(
      tap(o => this.items.push(o)),
      tap(o => this.cd.detectChanges()),
      tap(o => this.changes.emit(this.items))
    ).subscribe();
  }

  private listenDeleteItem() {
    this.keyValueService.listenDeleteItem().pipe(
      tap(i => this.items.splice(i, 1)),
      tap(o => this.cd.detectChanges()),
      tap(o => this.changes.emit(this.items))
    ).subscribe();
  }
}
